import { TagElementProps } from './types';
import React from 'react';
import { truncateString } from '../../../helpers/functions';

const TagElement = ({
  className,
  isDisabled,
  isSelected,
  isReadOnly,
  name,
  onTagClick,
  onCloseClick,
}: TagElementProps) => {
  const tagElementClassName = [
    className || '',
    'flex',
    'justify-center',
    'items-center',
    'rounded-xl',
    'px-2',
    'h-8.5',
    'min-w-max',
    'text-xs',
    'font-semibold',
    'select-none',
    'border',
    'truncate',
    isSelected ? 'bg-lime border-lime' : 'border-grey-10',
    'uppercase',
    isDisabled
      ? 'cursor-not-allowed text-grey-30 dark:bg-black dark:border-grey-70 dark:text-grey-70'
      : isReadOnly
      ? 'cursor-default bg-grey-10 dark:bg-grey-70 dark:border-grey-70 text-black dark:text-white'
      : 'cursor-pointer text-black dark:hover:border-grey-50 dark:border-grey-70 dark:bg-black dark:active:bg-black-light dark:text-white dark:active:border-black-light hover:bg-black hover:border-black hover:text-lime',
  ];

  const handleTagClick = (event) => {
    if (isDisabled) {
      return;
    }
    onTagClick?.(name);
  };

  const handleCloseClick = (event) => {
    onCloseClick?.(name);
  };

  return (
    <div className={tagElementClassName.join(' ')} onClick={handleTagClick}>
      {truncateString(name, 12)}
      {isSelected && (
        <div
          className="flex justify-center items-center w-3 h-3 ml-2 cursor-pointer"
          onClick={handleCloseClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            height="16"
            width="16"
            className="fill-current"
          >
            <path d="M14.7 1.3C14.3 0.9 13.7 0.9 13.3 1.3L8 6.6L2.7 1.3C2.3 0.9 1.7 0.9 1.3 1.3C0.9 1.7 0.9 2.3 1.3 2.7L6.6 8L1.3 13.3C0.9 13.7 0.9 14.3 1.3 14.7C1.5 14.9 1.7 15 2 15C2.3 15 2.5 14.9 2.7 14.7L8 9.4L13.3 14.7C13.5 14.9 13.8 15 14 15C14.2 15 14.5 14.9 14.7 14.7C15.1 14.3 15.1 13.7 14.7 13.3L9.4 8L14.7 2.7C15.1 2.3 15.1 1.7 14.7 1.3Z" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default TagElement;
